import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Grid, Button } from "@mui/material";
// import Fade from 'react-reveal/Fade';
// import FadeIn from 'react-fade-in';
// import FwSymbol from '../../../media/site_media/illustrations/withme/grey-logo.png'
import { gtag, install } from 'ga-gtag';
import axios from 'axios';
import { FcGoogle } from 'react-icons/fc';
import { FaApple, FaChevronDown } from 'react-icons/fa';
import BlueTick from '../../../media/site_media/illustrations/ComponentTickBlue@3x.png'
import paths from "../../../paths";
import SnackbarAlert from "../../common/SnackbarAlert";
import AppleLogin from 'react-apple-login'
import HeroBackgroundImage from '../../../media/site_media/sales_page/Background.webp';
import LongRightMobileGradient from '../../../media/site_media/sales_page/LongRightMobileGradient.webp'
// import HeroImage2D from '../../../media/site_media/sales_page/HeroImage2D.webp'
import { MainDescriptionA, MainDescriptionB } from "./SalesCopy";
import BackgroundTestImage from "../../../media/site_media/sales_page/BackgroundGradientCompressed.webp";
// import BackgroundTestImage from "../../../media/site_media/sales_page/BackgroundGradient.png";

import { useSearchParams } from "react-router-dom";
import HandMockupB from "../../../media/site_media/sales_page/BlueMockup.webp";
import HandMockupC from "../../../media/site_media/sales_page/HandMockupCompressed.webp";
import waitUntilConditionIsTrue from '../../../utils/waitUntilConditionIsTrue';
import AIAgentBanner from "./AIAgentBanner";
const hero_keypoints = [
   'Quick & Easy Setup',
   '20+ Monetization Tools',
   'Instant Payouts',
]

const SSOButtons = (props) => {
   const { t } = useTranslation();
   const processAppleSSO = (token, firstName, lastName, apiUrl) => {
      const form_data = new FormData()
      form_data.append('token', token)
      const realName = `${firstName} ${lastName}`
      const displayName = `${firstName}${lastName}`
      form_data.append('real_name', realName)
      form_data.append('display_name', displayName)
      axios.post(
         apiUrl,
         form_data,
         { withCredentials: true }
      ).then(res => {
         window.location.assign(res['data']['redirect_url'])
      }).catch(() => props.setRegisterIsLoading(false))
   }
   return (
      <Grid style={props.containerStyle ? props.containerStyle : {}}>
         <Button
            style={props.googleBtnStyle}
            onClick={
               () => {
                  props.setRegisterIsLoading(true);
                  gtag('event', 'landing_page_social_signup_lead', {
                     'event_category': 'Lead',
                     'event_label': 'Landing Page Lead (Google)'
                  });
                  let site = 'fitwith'
                  if (window.location.origin.includes('withme.so')) {
                     site = 'withme'
                  }
                  if ((props.referralId != null) & (props.referralId != '')) {
                     window.location.assign(paths.BACKEND_URL + 'oauth/login/google-oauth2?next=/api/social/confirm_profile_direct_influencer/' + props.referralId + '/null/' + props.utmSource + '/' + props.utmMedium + '/' + props.utmCampaign + '/' + props.utmContent + '/' + props.utmTerm + '/' + site)
                  } else if ((props.passiveReferralId != null) & (props.passiveReferralId != '')) {
                     window.location.assign(paths.BACKEND_URL + 'oauth/login/google-oauth2?next=/api/social/confirm_profile_passive_influencer/' + props.passiveReferralId + '/' + props.utmSource + '/' + props.utmMedium + '/' + props.utmCampaign + '/' + props.utmContent + '/' + props.utmTerm + '/' + site)
                  } else {
                     window.location.assign(paths.BACKEND_URL + 'oauth/login/google-oauth2?next=/api/social/confirm_profile_passive_influencer/null/' + props.utmSource + '/' + props.utmMedium + '/' + props.utmCampaign + '/' + props.utmContent + '/' + props.utmTerm + '/' + site)
                  }
               }
            }
         >
            <FcGoogle size={19} style={{ marginRight: '8px' }} /> {t('marketing.hero.signUpWithGoogle')}
         </Button>
         <AppleLogin
            render={({ onClick }) =>
               <Button
                     onClick={async () => {
                        window.deferApple && window.deferApple();
                        try { await waitUntilConditionIsTrue(() => window.AppleID && window.AppleID.auth); } catch {}
                        onClick();
                     }}
                  style={props.appleBtnStyle}>
                  <FaApple size={19} style={{ marginRight: '8px' }} /> {t('marketing.hero.signUpWithApple')}
               </Button>
            }
            clientId="so.withme"
            redirectURI={`${window.location.origin}/login`}
            responseType="code id_token"
            responseMode="query"
            usePopup={true}
            scope="name email"
            callback={(res) => {
               if (!res['error']) {
                  props.setRegisterIsLoading(true)
                  let site = 'fitwith'
                  if (window.location.origin.includes('withme.so')) {
                     site = 'withme'
                  }
                  const token = res['authorization']['id_token']
                  let firstName = null
                  let lastName = null
                  if (res['user']) {
                     // User's email and name only returned the first time, or after unlinking in apple id settings
                     firstName = res['user']['name']['firstName']
                     lastName = res['user']['name']['lastName']
                  }
                  if ((props.referralId != null) & (props.referralId != '')) {
                     const apiUrl = paths.BACKEND_URL + 'api/social/confirm_profile_influencer_direct_apple/'
                        + props.referralId + '/null/' + props.utmSource + '/' + props.utmMedium + '/' + props.utmCampaign + '/' + props.utmContent + '/' + props.utmTerm + '/' + site
                     processAppleSSO(token, firstName, lastName, apiUrl)
                  } else if ((props.passiveReferralId != null) & (props.passiveReferralId != '')) {
                     const apiUrl = paths.BACKEND_URL + 'api/social/confirm_profile_influencer_passive_apple/'
                        + props.passiveReferralId + '/' + props.utmSource + '/' + props.utmMedium + '/' + props.utmCampaign + '/' + props.utmContent + '/' + props.utmTerm + '/' + site
                     processAppleSSO(token, firstName, lastName, apiUrl)
                  } else {
                     const apiUrl = paths.BACKEND_URL + 'api/social/confirm_profile_influencer_passive_apple/'
                        + 'null' + '/' + props.utmSource + '/' + props.utmMedium + '/' + props.utmCampaign + '/' + props.utmContent + '/' + props.utmTerm + '/' + site
                     processAppleSSO(token, firstName, lastName, apiUrl)
                  }
               }
            }}
         />
      </Grid>
   )
}

export default function Hero(props) {
   const { t } = useTranslation();
   // console.log('pre-inf', props.pre_influencer, 'bool', props.influencer_bool)
    const [searchParams, setSearchParams] = useSearchParams();
   return (
      <>
         {
            props.windowWidth >= 1200 ?
               // DESKTOP & LARGE DEVICES
               <Grid container hide-scroll sx={{
                  minHeight: '900px',
                  height: '100vh', maxHeight: '100%', width: '100%',
                  overflow: 'hidden',
                  backgroundImage: `url(${BackgroundTestImage})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'bottom right',
                  position: 'relative',
                  backgroundRepeat: 'no-repeat',
                  backgroundColor: '#FFF',
               }}>
                  {/*  HERO TEXT SECTION  */}
                  <Grid xs={12} sm={12} md={5.5} lg={5.5} className={'hide-scroll'}
                     sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center", zIndex: '10' }}>
                     <div className={'hero_text_container hide-scroll'} style={{ marginTop: '40px', marginLeft: '5vw', maxWidth: '570px', }}>
                        <AIAgentBanner />
                        {/* <h2 style={{ ...props.mainHeader, textAlign: 'left', fontSize: props.windowWidth < 600 ? '38px' : '42px' }}>The <span style={{ fontFamily: 'GABWRWFFR', fontSize: '38px' }}>all-in-one</span> app for creating recurring revenue</h2> */}
                        <h2 style={{ ...props.mainHeader, textAlign: 'left', fontSize: props.windowWidth < 600 ? '34px' : '38px', }}>{t('marketing.hero.mainHeaderDesktop')}</h2>
                        <p style={{ ...props.mainDescription, fontSize: props.windowWidth < 600 ? '15px' : '18px', textAlign: 'left', margin: '0px 0px 30px 0px' }}>{t('marketing.hero.mainDescription')}</p>
                        {/* <p className={'hero_free_text'}>Start your free trial today 👇</p> */}
                        {props.logged_in === true ?
                           <Button variant="contained"
                              // href={window.location.href.includes('become-a-creator') ? '/become-a-creator#sign_up' : "/#sign_up"}
                              onClick={() => window.location.assign(props.pre_influencer === true && props.influencer_bool !== true ? '/become-a-creator/start-free-trial' :  (props.pre_influencer === false && props.influencer_bool !== true ? '/become-a-creator/register' : '/' + props.current_user))}
                              disableElevation
                              sx={{
                                 padding: props.windowWidth < 450 ? '10px 30px' : '10px 40px', display: 'inline-block', margin: '0px auto 10px 0px', borderRadius: '10px', textTransform: 'none',
                                 backgroundColor: 'var(--brand-color)', filter: 'drop-shadow(2px 4px 6px rgba(1,1,1,0.1))', '&:hover': { backgroundColor: 'var(--brand-color-hover)' }
                              }}>
                              <span className="fa fa-search" style={{ fontWeight: '600', fontSize: '20px' }}>
                                 {props.pre_influencer === true && props.influencer_bool === true ? t('marketing.hero.myHub') : props.pre_influencer === true || props.influencer_bool === false ? t('marketing.hero.continueForFree') : props.windowWidth >= 1000 ? t('marketing.hero.myHub') : t('marketing.hero.myHub')}
                                 {/* {console.log('pre-inf', props.pre_influencer, 'bool', props.influencer_bool)} */}
                              </span>
                           </Button>
                           :
                           <>
                              <>
                                 <Grid
                                    xs={12}
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'center'}
                                    style={{ margin: "0 " }}>
                                    <Grid style={{ margin: "auto 0 10px 0" }}>
                                       <Button variant="contained"
                                          onClick={() => {
                                             let direct_url = ''
                                             let referralId = searchParams.get("id");
                                             let passiveReferralId = searchParams.get("passive_id");
                                             if (referralId != null){
                                                direct_url = '/become-a-creator/register?id='+referralId
                                             } else if (passiveReferralId != null) {
                                                direct_url = '/become-a-creator/register?passive_id='+passiveReferralId
                                             } else {
                                                direct_url = '/become-a-creator/register'
                                             }
                                             window.location.assign(direct_url)
                                          }}
                                          disableElevation
                                          sx={{
                                             padding: props.windowWidth < 450 ? '12px 12px' : '12px 24px', display: 'inline-block', margin: '0px auto 10px 0px', borderRadius: '10px', textTransform: 'none',
                                             backgroundColor: 'var(--brand-color)', filter: 'drop-shadow(2px 4px 6px rgba(1,1,1,0.1))', '&:hover': { backgroundColor: 'var(--brand-color-hover)' }
                                          }}
                                       >
                                          <span className="fa fa-search" style={{ fontWeight: '600', fontSize: '20px' }}>
                                             {t('marketing.hero.start14DaysFree')}
                                          </span>
                                       </Button>
                                    </Grid>
                                 </Grid>
                              </>
                           </>
                        }
                        {/* <div style={{ marginTop: '10px', zIndex: '10' }}>
                           <span style={{ lineHeight: '24px', }}> <img src={BlueTick} style={{ width: '14px', height: '14px' }} /><span className={'hero-tick-text'} style={{ fontSize: '13px' }}>{hero_keypoints[0]}</span></span>
                           <span style={{ lineHeight: '24px', }}> <img src={BlueTick} style={{ width: '14px', height: '14px' }} /><span className={'hero-tick-text'} style={{ fontSize: '13px' }}>{hero_keypoints[1]}</span></span>
                           <span style={{ lineHeight: '24px', }}> <img src={BlueTick} style={{ width: '14px', height: '14px' }} /><span className={'hero-tick-text'} style={{ fontSize: '13px', paddingRight: '0px' }}>{hero_keypoints[2]}</span></span>
                        </div> */}
                        {/* </FadeIn> */}
                     </div>
                  </Grid>

                  {/*  HERO IMAGE SECTION  */}
                  <Grid xs={12} sm={12} md={6.2} lg={6.2} xl={6.2} className={'hide-scroll'}
                     sx={{ minHeight: '100%', width: '100%', display: "flex", justifyContent: "flex-end", alignItems: "center", overflow: 'hidden', }}>
                    {/* <Fade right> */}
                    <picture style={{ position: 'absolute',
                                 minHeight: '600px',
                                 right: props.windowWidth < 1300 ? '-100px' : (props.windowWidth < 1400 ? '-50px' : (props.windowWidth < 1500 ? '-50px' : '20px')),
                                 bottom: '0px',
                                 width: 'auto',
                                 height: props.windowWidth < 1300 ? '65vh' : (props.windowWidth < 1400 ? '70vh' : (props.windowWidth < 1500 ? '80vh' : '85vh')),
                                 zIndex: '1',
                           }}>
                     <source type="image/avif"
                              srcSet="/img/hero-400.avif 400w, /img/hero-800.avif 800w, /img/hero-1200.avif 1200w"
                              sizes="(max-width: 900px) 90vw, 600px" />
                     <source type="image/webp"
                              srcSet="/img/hero-400.webp 400w, /img/hero-800.webp 800w, /img/hero-1200.webp 1200w"
                              sizes="(max-width: 900px) 90vw, 600px" />
                     <img style={{ height: '100%', width: 'auto' }} src="/img/hero-800.webp" fetchpriority="high" loading="eager" alt={t('marketing.appPreviewOnPhone')}/>
                     </picture>
                    {/* </Fade> */}
                  </Grid>

                  <div style={{
                     position: 'relative',
                     zIndex: '999',
                     textAlign: 'center',
                     bottom: '100px',
                     right: '0px',
                     height: 'auto',
                     width: '100%'
                  }}>
                     <div
                        onClick={props.scrollToPartners}
                        style={{
                           color: 'white',
                           display: 'flex',
                           cursor: 'pointer',
                           alignItems: 'center',
                           justifyContent: 'center',
                           animation: 'bounce 2s infinite'
                        }}>
                        <FaChevronDown style={{ fontSize: '18px', color: '#fff' }} />
                        <p style={{ fontSize: '18px', fontWeight: '500', marginLeft: '10px' }}>{t('marketing.hero.scrollForMore')}</p>
                     </div>
                  </div>
                  <style>
                     {`
                           @keyframes bounce {
                              0%, 20%, 50%, 80%, 100% {
                              transform: translateY(0);
                              }
                              40% {
                              transform: translateY(-10px);
                              }
                              60% {
                              transform: translateY(-5px);
                              }
                           }
                        `}
                  </style>


                  <SnackbarAlert
                     msg={props.emailSubmit.message}
                     backgroundColor={'#3B55F3'}
                     open={props.emailSubmit.open}
                     severity={props.emailSubmit.severity}
                     handleClose={() => {
                        props.setEmailSubmit({
                           open: false,
                           severity: props.submitError ? 'error' : 'success',
                           message: ''
                        })
                     }}
                  />


               </Grid>
               :
               // MOBILES & TABLETS
               <Grid container sx={{
                  minHeight: '750px', height: 'auto', width: '100%', overflow: 'hidden', marginBottom: '60px',
                  backgroundImage: `url(${props.windowWidth < 900 ? LongRightMobileGradient : LongRightMobileGradient})`,
                  // backgroundImage: `url(${props.windowWidth < 600 ? MobileHeroGradient : HeroBackgroundImage})`,
                  backgroundSize: window.innerHeight < 800 ? '100% 900px' : '100% 100vh',

                  // backgroundSize: window.innerHeight < 700 ? '100% 700px' : '100% 100vh',
                  backgroundPosition: 'bottom left',
                  // backgroundPosition: props.windowWidth >= 1400 ? 'bottom right':'bottom right calc(100% + 280px)',
                  backgroundRepeat: 'no-repeat',
                  backgroundColor: '#FFF',
                  minWidth: '320px'
               }}>
                  <Grid xs={12} sx={{ justifyContent: "flex-start", alignItems: "center", position: 'relative' }}>

                     {/* <img src={props.windowWidth < 900 ? MobileHeroImage : MobileMain}
                        // <img src={props.windowWidth < 600 ? MobileHeroImage : MobileMain}

                        style={{ maxWidth: '100vw', width: '100%', minWidth: '320px', position: 'absolute', bottom: '0px', right: '0px', height: 'auto', zIndex: '0' }} /> */}
                     <div className={'hero_text_container_mobile'} style={{ marginTop: '100px', zIndex: '10' }}>
                        {/* <FadeIn delay={150}> */}
                        <AIAgentBanner />

                        {/* <h2 style={{ ...props.mainHeader, textAlign: 'left', fontSize: props.windowWidth < 600 ? '26px' : '34px' }}>The Fastest & Easiest way to Monetise your <span style={{ fontFamily: 'GABWRWFFR', fontSize: props.windowWidth < 600 ? '22px' : '30px' }}>Passion</span></h2> */}
                        {/* <h2 style={{ ...props.mainHeader, textAlign: 'left', }}>Transform Your <span style={{ fontFamily: 'GABWRWFFR', fontSize: props.windowWidth < 600 ? '22px' : '30px'  }}>Passion</span> into Predictable Income</h2> */}
                        {/* <h2 style={{ ...props.mainHeader, textAlign: 'left', }}>The <span style={{ fontFamily: 'GABWRWFFR', fontSize: props.windowWidth < 600 ? '26px' : '32px'  }}>Only</span> All-in-One Content Monetization Platform</h2> */}
                        {/* <h2 style={{ ...props.mainHeader, textAlign: 'left', }}>The <span style={{ fontFamily: 'GABWRWFFR', fontSize: props.windowWidth < 600 ? '26px' : '32px' }}>all-in-one</span> app for creating recurring revenue</h2> */}
                        {/* <h2 style={{ ...props.mainHeader, textAlign: 'left', fontSize: props.windowWidth < 600 ? '34px' : '38px' }}>The <span style={{ fontFamily: 'GABWRWFFR', fontSize: '32px' }}>all-in-one</span> app for creating recurring revenue</h2> */}
                        <h2 style={{ ...props.mainHeader, textAlign: 'left', fontSize: props.windowWidth < 600 ? '34px' : '38px' }}>{t('marketing.hero.mainHeaderMobile')}</h2>



                        <p style={{ ...props.mainDescription, fontSize: props.windowWidth < 600 ? '16px' : '20px', textAlign: 'left', margin: '0px 0px 40px 0px' }}>{t('marketing.hero.mainDescription')}</p>
                        {/* <div style={{ marginTop: '10px', zIndex: '10', }}>
                           <span style={{ lineHeight: '25px', display: 'block' }}> <img src={BlueTick} style={{ width: '14px', height: '14px' }} /><span className={'hero-tick-text'} style={{ fontSize: '14px' }}>{hero_keypoints[0]}</span></span>
                           <span style={{ lineHeight: '25px', display: 'block' }}> <img src={BlueTick} style={{ width: '14px', height: '14px' }} /><span className={'hero-tick-text'} style={{ fontSize: '14px' }}>{hero_keypoints[1]}</span></span>
                           <span style={{ lineHeight: '25px', display: 'block' }}> <img src={BlueTick} style={{ width: '14px', height: '14px' }} /><span className={'hero-tick-text'} style={{ fontSize: '14px' }}>{hero_keypoints[2]}</span></span>

                        </div> */}
                        {/* <p className={'hero_free_text'}>Start your free trial today 👇</p> */}

                        {props.logged_in === true ?
        
                           <Button variant="contained" 
                              onClick={() => window.location.assign(props.pre_influencer === true && props.influencer_bool !== true ? '/become-a-creator/start-free-trial' :  (props.pre_influencer === false && props.influencer_bool !== true ? '/become-a-creator/register' : '/' + props.current_user))}
                           disableElevation
                              sx={{
                                 padding: props.windowWidth < 450 ? '10px 30px' : '10px 40px', display: 'inline-block', margin: '0px auto 10px 0px', borderRadius: '10px', textTransform: 'none',
                                 backgroundColor: 'var(--brand-color)', filter: 'drop-shadow(2px 4px 6px rgba(1,1,1,0.1))', '&:hover': { backgroundColor: 'var(--brand-color-hover)' }
                              }}>
                           
                              <span className="fa fa-search" style={{ fontWeight: '600', fontSize: '18px' }}>
                              {props.pre_influencer === true && props.influencer_bool === true ? t('marketing.hero.myHub') : props.pre_influencer === true || props.influencer_bool === false ? t('marketing.hero.continueForFree') : props.windowWidth >= 1000 ? t('marketing.hero.myHub') : t('marketing.hero.myHub')}

                              {/* {props.pre_influencer === true && props.influencer_bool === true ? 'My Platform →' : props.pre_influencer === true || props.influencer_bool === false ? 'Continue for Free →' : props.windowWidth >= 1000 ? 'My Platform →' : 'My Platform →'} */}
                              </span>
                           </Button>
                           :
                           <>
                              <Button variant="contained"
                                 onClick={() => {
                                    let referralId = searchParams.get("id");
                                    let passiveReferralId = searchParams.get("passive_id");
                                    let direct_url = ''
                                    if (referralId != null){
                                       direct_url = '/become-a-creator/register?id='+referralId
                                    } else if (passiveReferralId != null) {
                                       direct_url = '/become-a-creator/register?passive_id='+passiveReferralId
                                    } else {
                                       direct_url = '/become-a-creator/register'
                                    }
                                    window.location.assign(direct_url)
                                 }}
                                 disableElevation
                                 sx={{
                                    padding: props.windowWidth < 450 ? '10px 30px' : '10px 40px', display: 'inline-block', margin: '0px auto 10px 0px', borderRadius: '10px', textTransform: 'none',
                                    backgroundColor: 'var(--brand-color)', filter: 'drop-shadow(2px 4px 6px rgba(1,1,1,0.1))', '&:hover': { backgroundColor: 'var(--brand-color-hover)' }
                                 }}>
                                 <span className="fa fa-search" style={{ fontWeight: '600', fontSize: '18px' }}>
                                 {t('marketing.hero.start14DaysFree')}
                                 </span>
                              </Button>
                           </>
                        }

                     </div>
                     <div style={{ display: 'flex', width: '100%', height: 'auto', }}>
                     <picture style={{ display: 'block', position: 'relative', zIndex: '1', width: '100%', height: '100%' }}>
                        <source
                           type="image/avif"
                           srcSet="/img/hero-400.avif 400w, /img/hero-800.avif 800w, /img/hero-1200.avif 1200w"
                           sizes="(max-width: 900px) 90vw, 600px" />
                        <source
                           type="image/webp"
                           srcSet="/img/hero-400.webp 400w, /img/hero-800.webp 800w, /img/hero-1200.webp 1200w"
                           sizes="(max-width: 900px) 90vw, 600px" />
                        <img
                           className={'hide-scroll'}
                           src="/img/hero-800.webp"
                           alt={t('marketing.appPreviewOnPhone')}
                           fetchpriority="high"
                           loading="eager"
                           width={600}
                           height={588}
                           style={{
                              width: props.windowWidth < 390 ? '90%' : // Small mobile
                                    props.windowWidth < 600 ? '95%' : // Large mobile  
                                    props.windowWidth < 1280 ? '85%' : // iPad
                                    '400px', // Desktop
                              maxWidth: props.windowWidth < 390 ? '300px' :
                                       props.windowWidth < 600 ? '400px' :
                                       props.windowWidth < 1280 ? '600px' :
                                       '500px',
                              height: 'auto',
                              right: props.windowWidth < 1280 ? '0px' : '30px', 
                              margin: props.windowWidth < 1280 ? '40px auto 0' : '0 0 0 auto',
                              position: 'relative',
                              overflowY: 'hidden',
                              objectFit: 'contain',
                              display: 'block'
                           }}
                        />
                        </picture>
                     </div>

                     <SnackbarAlert
                        msg={props.emailSubmit.message}
                        backgroundColor={'#3B55F3'}
                        open={props.emailSubmit.open}
                        severity={props.emailSubmit.severity}
                        handleClose={() => {
                           props.setEmailSubmit({
                              open: false,
                              severity: props.submitError ? 'error' : 'success',
                              message: ''
                           })
                        }}
                     />
                  </Grid>






               </Grid>


         }

      </>
   )
}
